module.exports = require("ember-testing/lib/test/pending_requests");